<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 273.622 429.537">
  <path
    id="Path_43"
    data-name="Path 43"
    d="M59.993,26.149H136.94c3.978,0,7.2-2.6,7.2-5.8V0H52.792V20.345c0,3.206,3.223,5.8,7.2,5.8"
    transform="translate(38.346 0.001)"
    fill="#68b9f4"
  />
</svg>
